// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"3027f91b","255":"e0eb44e5","428":"31c27481","453":"05e1eb3e","466":"00dcfe25","487":"578026e2"}[chunkId] + ".chunk.js";
};